import SelectedNameComponent from "select-kit/components/selected-name";
export default SelectedNameComponent.extend({
  tagName: ""
});